import { render, staticRenderFns } from "./ToplamB2BSiparisSayisi.vue?vue&type=template&id=0814c60c&scoped=true"
import script from "./ToplamB2BSiparisSayisi.vue?vue&type=script&lang=js"
export * from "./ToplamB2BSiparisSayisi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0814c60c",
  null
  
)

export default component.exports